import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import RouteDetails from './RouteDetails';
import { onDragEnd } from '../../utils/dragDrop';

export default {
  title: 'Components/RouteDetails',
  component: RouteDetails,
  parameters: {
    layout: 'centered',
  },
  tags: ['autodocs'],
};

// Base Template function for stories
const RouteDetailsTemplate = ({
  routeDate, sitesArray, totalDistance = 0, totalTime = 0,
}) => {
  const [items, setItems] = useState(sitesArray);

  useEffect(() => {
    setItems(sitesArray);
  }, [sitesArray]);

  const storyBookOnDragEnd = (result) => {
    onDragEnd(result, items, setItems);
  };
  return (
    <RouteDetails
      routeDate={routeDate}
      sitesArray={items}
      onDragEnd={storyBookOnDragEnd}
      totalDistance={totalDistance}
      totalTime={totalTime}
    />
  );
};

RouteDetailsTemplate.propTypes = {
  routeDate: PropTypes.string.isRequired,
  sitesArray: PropTypes.array.isRequired,
  totalDistance: PropTypes.number,
  totalTime: PropTypes.number,
};

// Binding the base template
const Template = RouteDetailsTemplate.bind({});

// STORIES

// Default - No Sites
export const NoSites = Template.bind({});
NoSites.args = {
  routeDate: '12/01/23',
  sitesArray: [],
};

// One Site
export const OneSite = Template.bind({});
OneSite.args = {
  routeDate: '12/01/23',
  sitesArray: [
    {
      organization_id: 1,
      id: 1,
      name: 'MacFarlane Ranch',
      distance: 0,
      time: 0,
      icon: 'Dairy',
    },
  ],
};

// Multiple Sites
export const MultipleSites = Template.bind({});
MultipleSites.args = {
  routeDate: '12/01/23',
  totalDistance: 80,
  totalTime: 7000,
  sitesArray: [
    {
      organization_id: 1,
      id: 1,
      site_name: 'MacFarlane Ranch',
      distance: 0,
      time: 0,
      icon: 'Dairy',
      position: 1,
    },
    {
      organization_id: 1,
      id: 2,
      site_name: 'Wild Edge Farm',
      distance: 50,
      time: 4000,
      icon: 'Worksite',
      position: 2,
    },
    {
      organization_id: 1,
      id: 3,
      site_name: 'Pepperidge Farm',
      distance: 30,
      time: 3000,
      icon: 'Family',
      position: 3,
    },
  ],
};
